import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { CONFIGURE_TAB } from '../../../constants/configure';

import Loading from '../../../components/Loading';
import ConfigureEmptyView from '../ConfigureEmptyView/ConfigureEmptyView';
import PaginatedContainer from '../../../components/PaginatedContainer/PaginatedContainer';
import CycleCard from '../CycleCard/CycleCard';
import ProcessCard from '../ProcessCard/ProcessCard';
import PlaybookCard from '../PlaybookCard/PlaybookCard';

const ConfigurePaginatedContainer = ({
    activeTab,
    configureDataHookResponse,
    keysToMutate,
    setCreateModal,
}) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const page = Number.parseInt(searchParams.get('page')) || 1;

    const { total, data, loading, count } = configureDataHookResponse;

    if (!total && loading) {
        return (
            <div className="absolute top-1/2 left-1/2 transform translate-x-[-50%] translate-y-[-50%] flex items-center">
                <Loading />
            </div>
        );
    }

    const emptyStateShown = !total && !data?.length && !loading;

    if (emptyStateShown) {
        const handleCreate = () => {
            if (activeTab === CONFIGURE_TAB.playbooks) {
                setCreateModal({ type: 'playbook' });
            }

            if (activeTab === CONFIGURE_TAB.cycles) {
                setCreateModal({ type: 'cycle' });
            }

            if (activeTab === CONFIGURE_TAB.processes) {
                navigate('/configure/process/new', {
                    state: { configureSearchParams: location.search },
                });
            }
        };

        return <ConfigureEmptyView activeTab={activeTab} handleClick={handleCreate} />;
    }

    const hasData = !!data?.length;

    return (
        <PaginatedContainer page={page} count={count} total={total}>
            {hasData && (
                <ul className="flex flex-col gap-2">
                    {activeTab === CONFIGURE_TAB.processes && (
                        <>
                            {data.map((process) => (
                                <ProcessCard
                                    key={process.id}
                                    process={process}
                                    keysToMutate={keysToMutate[CONFIGURE_TAB.processes]}
                                />
                            ))}
                        </>
                    )}
                    {activeTab === CONFIGURE_TAB.playbooks && (
                        <>
                            {data.map((playbook) => (
                                <PlaybookCard
                                    key={playbook.id}
                                    playbook={playbook}
                                    keysToMutate={keysToMutate[CONFIGURE_TAB.playbooks]}
                                />
                            ))}
                        </>
                    )}
                    {activeTab === CONFIGURE_TAB.cycles && (
                        <>
                            {data.map((cycle) => (
                                <CycleCard
                                    key={cycle.id}
                                    cycle={cycle}
                                    keysToMutate={keysToMutate[CONFIGURE_TAB.cycles]}
                                />
                            ))}
                        </>
                    )}
                </ul>
            )}
        </PaginatedContainer>
    );
};

export default ConfigurePaginatedContainer;
